import { render, staticRenderFns } from "./WhitelistMaintenance.vue?vue&type=template&id=0413b04e&lang=pug"
import script from "./WhitelistMaintenance.vue?vue&type=script&lang=js"
export * from "./WhitelistMaintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0413b04e')) {
      api.createRecord('0413b04e', component.options)
    } else {
      api.reload('0413b04e', component.options)
    }
    module.hot.accept("./WhitelistMaintenance.vue?vue&type=template&id=0413b04e&lang=pug", function () {
      api.rerender('0413b04e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/configuration/WhitelistMaintenance.vue"
export default component.exports